/**
 * @generated SignedSource<<d35e2560fdd891f0148a0a94c0078dfd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ViewInRoom_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ViewInRoomImageCredits_item" | "ViewInRoomImage_item">;
  readonly " $fragmentType": "ViewInRoom_item";
};
export type ViewInRoom_item$key = {
  readonly " $data"?: ViewInRoom_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ViewInRoom_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ViewInRoom_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ViewInRoomImage_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ViewInRoomImageCredits_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "6d3d85fdf54fbe642b17d7db6110ded2";

export default node;
